import React from "react";
import { Link } from "react-router-dom";
import Layout from "../Landing/Layout";
import insightsData from "./insightsData";
import "./insights.css";

const InsightPost = ({ match }) => {
    const { slug } = match.params;
    const post = insightsData.find((p) => p.slug === slug);

    if (!post) {
        return (
            <Layout>
                <div className="insights-page">
                    <div className="insight-article">
                        <Link to="/insights" className="insight-back">
                            &larr; Back to Insights
                        </Link>
                        <h1 className="insight-article-title">Post not found</h1>
                        <p style={{ fontFamily: "Inter, sans-serif", color: "#888" }}>
                            The article you&rsquo;re looking for doesn&rsquo;t exist.
                        </p>
                    </div>
                </div>
            </Layout>
        );
    }

    /* pick 3 related posts from same category, excluding current */
    const related = insightsData
        .filter((p) => p.category === post.category && p.id !== post.id)
        .slice(0, 3);

    return (
        <Layout>
            <div className="insights-page">
                {/* ── Article ── */}
                <article className="insight-article">
                    <Link to="/insights" className="insight-back">
                        &larr; Back to Insights
                    </Link>

                    <div className="insight-article-cat">{post.category}</div>

                    <h1 className="insight-article-title">{post.title}</h1>

                    <div className="insight-article-meta">
                        <span>{post.date}</span>
                        <span className="insight-card-divider" />
                        <span>{post.readTime}</span>
                    </div>

                    <div className="insight-article-content">
                        {post.content.map((block, i) => {
                            switch (block.type) {
                                case "heading":
                                    return <h2 key={i}>{block.text}</h2>;
                                case "paragraph":
                                    return <p key={i}>{block.text}</p>;
                                case "list":
                                    return (
                                        <ul key={i}>
                                            {block.items.map((item, j) => (
                                                <li key={j}>{item}</li>
                                            ))}
                                        </ul>
                                    );
                                case "quote":
                                    return (
                                        <div className="insight-article-quote" key={i}>
                                            <p>{block.text}</p>
                                        </div>
                                    );
                                default:
                                    return <p key={i}>{block.text}</p>;
                            }
                        })}
                    </div>
                </article>

                {/* ── Related Posts ── */}
                {related.length > 0 && (
                    <section className="insight-related">
                        <h3>More from {post.category}</h3>
                        <div className="insight-related-grid">
                            {related.map((r) => (
                                <Link
                                    key={r.id}
                                    to={`/insights/${r.slug}`}
                                    className="insight-card"
                                >
                                    <div className="insight-card-body">
                                        <div className="insight-card-cat">{r.category}</div>
                                        <h2 className="insight-card-title">{r.title}</h2>
                                        <p className="insight-card-excerpt">{r.excerpt}</p>
                                        <div className="insight-card-meta">
                                            <span>{r.date}</span>
                                            <span className="insight-card-divider" />
                                            <span>{r.readTime}</span>
                                        </div>
                                        <span className="insight-card-link">
                                            Read more &rarr;
                                        </span>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    </section>
                )}
            </div>
        </Layout>
    );
};

export default InsightPost;
